export const MOBILE_BREAKPOINT: number = 768;

export type ComponentSize = 'xs' | 's' | 'm' | 'l' | '';
export type HorizontalAlign = 'left' | 'center' | 'right' | '';

export type VerticalAlign = 'top' | 'bottom' | 'center' | '';
export type PageTypes = 'page' | 'wine'